import type { Dispatch, ReactNode, SetStateAction } from 'react'
import type { PaginationState, SortingState } from '@tanstack/react-table'
import { SamplesCardList } from '../samples-card-list/SamplesCardList'
import { SamplesTable } from '../../tables/samples-table/SamplesTable'
import type { Samples } from '../../types/types'

export type SamplesViewMode = 'card' | 'table'

type SamplesViewProps = {
  mode: SamplesViewMode
  samples: Samples
  loaderContent?: ReactNode
  cardView?: 'compact' | 'expanded'
  table?: {
    grouping?: string[]
    rowCount: number
    pagination: PaginationState
    setPagination: Dispatch<SetStateAction<PaginationState>>
    sorting: SortingState
    setSorting: Dispatch<SetStateAction<SortingState>>
    hiddenColumnIds?: string[]
  }
}

export function SamplesView({
  mode,
  samples,
  loaderContent,
  cardView,
  table
}: Readonly<SamplesViewProps>) {
  if (mode === 'card') {
    return (
      <SamplesCardList
        samples={samples}
        loaderContent={loaderContent}
        cardView={cardView}
      />
    )
  }

  if (table == null) {
    throw new Error('SamplesView requires table props in table mode.')
  }

  return (
    <SamplesTable
      data={samples}
      grouping={table.grouping}
      rowCount={table.rowCount}
      pagination={table.pagination}
      setPagination={table.setPagination}
      sorting={table.sorting}
      setSorting={table.setSorting}
      hiddenColumnIds={table.hiddenColumnIds}
    />
  )
}
